import { EmailReminder, RelativeTo } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface EmailTemplateSchedulerState {
  emailRemindersRelativeTo: RelativeTo;
  emailReminders: EmailReminder[];
}

const formSlice = createGenericFormSlice({
  name: "emailTemplateScheduler",
  initialState: {} as SliceState<EmailTemplateSchedulerState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const emailTemplateSchedulerReducer = formSlice.reducer;
export default emailTemplateSchedulerReducer;
